import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedLanguageSelect } from './language-select';
import { ConnectedCurrencySelect } from './currency-select';
import { ConnectedShippingCountrySelect } from './shipping-country-select';

export const LocalizationMenu = ({
    idPrefix,
    onBlur,
    showCurrencySelection,
    showRegionSelection,
    className
}) => (
    <div className={className}>
        {showRegionSelection && (
            <>
                <ConnectedShippingCountrySelect
                    onShippingCountrySelected={onBlur}
                />
                <div className="border-bottom" />
            </>
        )}
        <>
            <ConnectedLanguageSelect
                idPrefix={idPrefix}
                onLanguageSelected={onBlur}
            />
            <div className="border-bottom" />
        </>
        {showCurrencySelection && (
            <ConnectedCurrencySelect
                idPrefix={idPrefix}
                onCurrencySelected={onBlur}
            />
        )}
    </div>
);

LocalizationMenu.propTypes = {
    idPrefix: PropTypes.string,
    showRegionSelection: PropTypes.bool.isRequired,
    showCurrencySelection: PropTypes.bool.isRequired,
    className: PropTypes.string
};

LocalizationMenu.defaultProps = {
    className: ''
};
